export default function () {
	return {
		category: 'all',
		department: 'all',
		reward_user_points: 0,
		reward_user_level_id: null,
		reward_user_level_points: 0
	}
}
